import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSquareCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 24,
	viewBox: "0 0 21 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3 1.5H18C19.6406 1.5 21 2.85938 21 4.5V19.5C21 21.1875 19.6406 22.5 18 22.5H3C1.3125 22.5 0 21.1875 0 19.5V4.5C0 2.85938 1.3125 1.5 3 1.5ZM15.7969 9.79688H15.75C16.2188 9.375 16.2188 8.67188 15.75 8.20312C15.3281 7.78125 14.625 7.78125 14.2031 8.20312L9 13.4531L6.79688 11.25C6.32812 10.7812 5.625 10.7812 5.20312 11.25C4.73438 11.6719 4.73438 12.375 5.20312 12.7969L8.20312 15.7969C8.625 16.2656 9.32812 16.2656 9.79688 15.7969L15.7969 9.79688Z",
		fill: "#107F47"
	})]
});
const ForwardRef = forwardRef(SvgIconSquareCheck);
export { ForwardRef as ReactComponent };
